export default __webpack_public_path__ + "static/media/team48.9b44cfed.JPG";